import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { RadiusParserPassword } from 'data/radiusParserPassword/radiusParserPassword.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  sipSettingData: RadiusParserPassword,
  originalDigitExtractionServerFormData: RadiusParserPassword | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.RADIUS_PARSER_PASSWORD_CREATE;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.RADIUS_PARSER_PASSWORD_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(sipSettingData, null, isEdit, originalDigitExtractionServerFormData),
    sipSettingData.id,
    AuditService.RADIUS_PARSER_PASSWORD,
    actionType,
  );
  return auditDetails as AuditDetails;
}
